module.exports = __webpack_public_path__ + "static/media/varilla_tapajuntas.4c81a899.jpg";